import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiMenu, FiX, FiSun, FiMoon } from "react-icons/fi";

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [darkMode, setDarkMode] = useState(
        localStorage.getItem("theme") === "dark"
    );

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add("dark");
            localStorage.setItem("theme", "dark");
        } else {
            document.documentElement.classList.remove("dark");
            localStorage.setItem("theme", "light");
        }
    }, [darkMode]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <>
            <nav className={`fixed hidden md:block w-full z-50 transition-all duration-300 ${scrolled
                ? "bg-white/90 dark:bg-slate-900/90 backdrop-blur-md"
                : "bg-transparent"
                }`}>
                <div className="mx-auto py-4 px-6 md:px-12 lg:px-32 flex items-center justify-between">
                    <div
                        onClick={() => navigate("/")}
                        className="relative flex flex-col justify-start text-xl md:text-[27px] font-bold cursor-pointer group"
                    >
                        <span className="text-gray-700 dark:text-gray-200 transition-all duration-300 transform group-hover:text-gray-900 dark:group-hover:text-white">
                            Piyush <span className="text-gray-900 dark:text-white">Joshi</span>
                        </span>
                        <div className="h-1 w-16 mt-0.5 bg-black dark:bg-white rounded-full transform origin-left transition-all duration-300 group-hover:w-full"></div>
                    </div>
                    <div className="hidden md:flex items-center space-x-8 text-base font-medium">
                        {[
                            { path: "/", label: "Home" },
                            { path: "/resume", label: "Resume" },
                            { path: "/projects", label: "Projects" },
                            { path: "/contactme", label: "Contact" }
                        ].map((item) => (
                            <a
                                key={item.path}
                                href={item.path}
                                className={`relative px-2 py-1 ${isActive(item.path)
                                    ? "text-gray-900 dark:text-white"
                                    : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                    } transition-all duration-300 nav-link`}
                            >
                                {item.label}
                                {isActive(item.path) && (
                                    <span className="absolute bottom-[-4px] left-0 w-full h-0.5 bg-black dark:bg-white rounded-full"></span>
                                )}
                            </a>
                        ))}
                        <button
                            onClick={() => setDarkMode(!darkMode)}
                            className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
                            aria-label="Toggle Dark Mode"
                        >
                            {darkMode ? <FiSun className="text-yellow-400" size={20} /> : <FiMoon className="text-gray-600" size={20} />}
                        </button>
                    </div>
                    <div className="md:hidden flex items-center space-x-4">
                        <button
                            onClick={() => setDarkMode(!darkMode)}
                            className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
                            aria-label="Toggle Dark Mode"
                        >
                            {darkMode ? <FiSun className="text-yellow-400" size={24} /> : <FiMoon className="text-gray-600" size={24} />}
                        </button>
                        <button
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            className="text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors duration-300"
                        >
                            {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
                        </button>
                    </div>
                </div>
            </nav>

            <div className={`fixed inset-0 z-40 bg-white/95 dark:bg-slate-900/95 backdrop-blur-lg transform transition-transform duration-300 ${mobileMenuOpen ? "translate-x-0" : "translate-x-full"
                } md:hidden flex flex-col justify-center items-center`}>
                <div className="flex flex-col space-y-6 text-center">
                    {[
                        { path: "/", label: "Home" },
                        { path: "/resume", label: "Resume" },
                        { path: "/projects", label: "Projects" },
                        { path: "/contactme", label: "Contact" }
                    ].map((item) => (
                        <a
                            key={item.path}
                            href={item.path}
                            onClick={() => setMobileMenuOpen(false)}
                            className={`text-xl font-medium ${isActive(item.path)
                                ? "text-gray-900 dark:text-white"
                                : "text-gray-600 dark:text-gray-400"
                                } hover:text-gray-900 dark:hover:text-white transition-all duration-300`}
                        >
                            {item.label}
                        </a>
                    ))}
                </div>
            </div>

            <style jsx>{`
                .nav-link::after {
                    content: '';
                    position: absolute;
                    bottom: -4px;
                    left: 0;
                    width: 0;
                    height: 0.5px;
                    background: #000;
                    transition: width 0.3s ease;
                    border-radius: 9999px;
                }
                
                :global(.dark) .nav-link::after {
                    background: #fff;
                }
                
                .nav-link:hover::after {
                    width: 100%;
                }
            `}</style>
        </>
    );
};

export default Navbar;
